import { ReactNode } from "react";

export const Nights = ({ children }: { children: ReactNode }) => (
  <span className="ml-2 whitespace-nowrap text-[16px] font-light leading-5 text-neutral-70">
    / {children}
  </span>
);
